/**
 * Swiper React 6.3.3
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://swiperjs.com
 *
 * Copyright 2014-2020 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: October 9, 2020
 */

import { Swiper } from './esm/react/swiper';
import { SwiperSlide } from './esm/react/swiper-slide';
export { Swiper, SwiperSlide };



//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/super-x.blog/httpdocs/~/swiper/swiper-react.esm.js
// module id = 537
// module chunks = 0